import { useState, useEffect } from 'react';
import { DateTime } from 'luxon';

const checkIsDismissed = (id: string): boolean => {
  const dismissedBanners = localStorage.getItem('dismissedBanners');
  return dismissedBanners ? JSON.parse(dismissedBanners).includes(id) : false;
};

const checkIsActive = (startDate?: string, endDate?: string): boolean => {
  const now = DateTime.local();
  const startValid = startDate ? now >= DateTime.fromISO(startDate) : true;
  const endValid = endDate ? now <= DateTime.fromISO(endDate) : true;
  return startValid && endValid;
};

export const useBannerState = (banner: any) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const dismissBanner = () => {
    const dismissedBanners = localStorage.getItem('dismissedBanners');
    const updatedDismissedBanners = dismissedBanners
      ? [...JSON.parse(dismissedBanners), banner.id]
      : [banner.id];
    localStorage.setItem(
      'dismissedBanners',
      JSON.stringify(updatedDismissedBanners),
    );
    setIsDismissed(true);
  };

  useEffect(() => {
    if (!banner) return;

    setIsDismissed(checkIsDismissed(banner.id));
    setIsActive(checkIsActive(banner.startDate, banner.endDate));
  }, [banner]);

  return { isDismissed, isActive, dismissBanner };
};
